import * as types from '../actionTypes/index';
const initialState = {
  footerLinks : {},
}
const navigationReducer = (state = initialState, action) =>{
 
  switch (action.type) {
    case types.GET_FOOTER_LINKS_SUCCESS:
        return {
          ...state,
          footerLinks : action.payload.footerData
        }
    default:
        return state;
  }
};
export default navigationReducer;